import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IApplicationState } from "src/state";
import { fetchNonprofitRequest, INonprofitMiniProfile } from "src/state/nonprofit";

export interface INonprofitDataLoaderOwnProps {
  isAuthenticated: boolean;
  nonprofitProfile?: INonprofitMiniProfile;
  isLoading?: boolean;
}

export interface IPropsFromDispatch {
  fetchNonprofitRequest: typeof fetchNonprofitRequest;
}

export type INonprofitDataLoaderProps = IPropsFromDispatch & INonprofitDataLoaderOwnProps;

export class NonprofitDataLoader extends React.Component<INonprofitDataLoaderProps> {
  public componentDidMount() {
    this.fetchNonprofitIfNeeded();
  }

  public componentDidUpdate(prevProps: INonprofitDataLoaderProps) {
    // Fetch nonprofit data if authentication status changed to authenticated
    if (!prevProps.isAuthenticated && this.props.isAuthenticated) {
      this.fetchNonprofitIfNeeded();
    }
  }

  public render() {
    return null;
  }

  private fetchNonprofitIfNeeded = () => {
    const { isAuthenticated, nonprofitProfile, isLoading } = this.props;
    
    // Only fetch if user is authenticated and data hasn't been loaded and is not currently loading
    if (isAuthenticated && !nonprofitProfile && !isLoading) {
      this.props.fetchNonprofitRequest();
    }
  };
}

const mapStateToProps = ({ auth, nonprofit }: IApplicationState) => ({
  isAuthenticated: auth.isAuthenticated,
  nonprofitProfile: nonprofit.miniProfile,
  isLoading: nonprofit.isLoading
});

const mapDispatchToProps = (dispatch: Dispatch): IPropsFromDispatch => ({
  fetchNonprofitRequest: () => dispatch(fetchNonprofitRequest())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NonprofitDataLoader);
